module.exports = __webpack_public_path__ + "static/media/herobox.cec41915.mp4";